export default __webpack_public_path__ + "712e6c265190435e0004d19e2e5de7a7.png";